import React from 'react';
import { Table, type TableProps } from 'antd';
import { ISummaryCostByBU } from '@/interfaces/inbound';
import TableComponent from '@/components/table';
import { formatNumber } from '@/utils/dataUtils';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { round } from 'lodash';
interface IProps {
  items: ISummaryCostByBU[];
}

const CostCalculationBUTable = ({ items }: IProps) => {
  dayjs.extend(relativeTime);
  const columns: TableProps<ISummaryCostByBU>['columns'] = [
    {
      title: 'BU',
      dataIndex: 'businessUnitName',
      key: 'businessUnitName',
      align: 'center',
      width: 60,
      className: 'font-bold',
    },
    {
      title: 'FREIGHT',
      dataIndex: 'totalFreight',
      key: 'totalFreight',
      className: 'font-bold',
      width: 100,
      align: 'right',
      render: _ => formatNumber(round(_, 2)),
    },
    {
      title: 'TAX',
      dataIndex: 'totalDuty',
      key: 'totalDuty',
      className: 'font-bold',
      width: 100,
      align: 'right',
      render: _ => formatNumber(round(_, 2)),
    },
    {
      title: 'AMOUNT THB',
      dataIndex: 'totalUnitCostTHB',
      key: 'totalUnitCostTHB',
      className: 'font-bold',
      width: 100,
      align: 'right',
      render: _ => formatNumber(round(_, 2)),
    },
    {
      title: 'VAT',
      dataIndex: 'totalVatCost',
      key: 'totalVatCost',
      className: 'font-bold',
      width: 100,
      align: 'right',
      render: _ => formatNumber(round(_, 2)),
    },
    {
      title: 'TOTAL',
      dataIndex: 'summaryCost',
      key: 'summaryCost',
      className: 'font-bold',
      width: 100,
      align: 'right',
      render: _ => formatNumber(round(_, 2)),
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <TableComponent<ISummaryCostByBU>
        columns={columns}
        criteria={undefined}
        data={{ data: items || [], totalRecords: items?.length }}
        loading={false}
        onTableChange={undefined}
        // scrollLength={1800}
        rowKey="businessUnitName"
        scroll
        showPagination={false}
        summary={(pageData: ISummaryCostByBU[]) => {
          let summary = 0;
          let duty = 0;
          let freight = 0;
          let thb = 0;
          let vat = 0;
          pageData.forEach(
            ({
              summaryCost,
              totalDuty,
              totalFreight,
              totalUnitCostTHB,
              totalVatCost,
            }) => {
              freight += round(totalFreight, 2);
              summary += round(summaryCost, 2);
              duty += round(totalDuty, 2);
              thb += round(totalUnitCostTHB, 2);
              vat += round(totalVatCost, 2);
            },
          );
          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell
                  index={8}
                  colSpan={1}
                  className="font-bold items-end"
                  align="right"
                ></Table.Summary.Cell>
                <Table.Summary.Cell
                  index={8}
                  colSpan={1}
                  className="font-bold items-end bg-red-100"
                  align="right"
                >
                  {formatNumber(freight, 2)}
                </Table.Summary.Cell>
                <Table.Summary.Cell
                  index={8}
                  colSpan={1}
                  className="font-bold items-end bg-red-100"
                  align="right"
                >
                  {formatNumber(duty, 2)}
                </Table.Summary.Cell>
                <Table.Summary.Cell
                  index={8}
                  colSpan={1}
                  className="font-bold items-end bg-red-100"
                  align="right"
                >
                  {formatNumber(thb, 2)}
                </Table.Summary.Cell>
                <Table.Summary.Cell
                  index={8}
                  colSpan={1}
                  className="font-bold items-end bg-red-100"
                  align="right"
                >
                  {formatNumber(vat, 2)}
                </Table.Summary.Cell>
                <Table.Summary.Cell
                  index={8}
                  colSpan={1}
                  className="font-bold items-end bg-red-100"
                  align="right"
                >
                  {formatNumber(summary, 2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
    </div>
  );
};

export default CostCalculationBUTable;
